import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

interface CurrencyRateResponse {
  rates: {
    [key: string]: number;
  };
  base: string;
}

@Injectable({
  providedIn: 'root'
})
export class CurrencyConvertService {
  originalCurrency: string = 'SAR';
  localCurrency: WritableSignal<string> = signal('SAR');
  localISO: WritableSignal<string> = signal('sa');
  http: HttpClient = inject(HttpClient);
  exchangeRates: any = {};
  constructor() {
    this.getUserIpData()
      .then(async () => {
        await this.getExchangeRate();
      });
  }

  getUserIpData() {
    return new Promise<any>((resolve, reject) => {
      this.http.get(`${environment.apiUrl}/user/my-ip`)
        .subscribe({
          next: (response: any) => {
            if (response.currencyCode) {
              // this.localCurrency.set(response.currencyCode);
              // this.localISO.set(response.countryCode.toLowerCase());
              this.localCurrency.set('SAR');
              this.localISO.set('sa');
            } else {
              this.localISO.set(response.countryCode);
              this.localCurrency.set('USD');
            }
            resolve(response);
          },
          error: error => reject(error)
        })
    })
  }

  async getExchangeRate() {
    const url = `https://api.exchangerate-api.com/v4/latest/${this.originalCurrency}`;
    return new Promise(async (resolve, reject) => {
      this.http.get<CurrencyRateResponse>(url)
        .subscribe({
          next: (response) => {
            this.exchangeRates = response.rates;
            resolve(response.rates[this.localCurrency()]);
          },
          error: (err) => {
            console.error(err);
            reject(err);
          }
        });
    })
  }
  async getExchangeRateFromCurrency(currency?: string) {
    const url = `https://api.exchangerate-api.com/v4/latest/${currency}`;
    return new Promise(async (resolve, reject) => {
      this.http.get<CurrencyRateResponse>(url)
        .subscribe({
          next: (response) => {
            resolve(response.rates[this.originalCurrency]);
          },
          error: (err) => {
            console.error(err);
            reject(err);
          }
        });
    })
  }
}
